import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchPendingIngredients() {
  try {
    const result = yield call(AxiosCall, `/mycore/ingredients/pending/`);

    yield put(actions.fetchPendingIngredientsSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchPendingIngredientsFailure(e));
  }
}

function* approveIngredient(action) {
  try {
    const { ingredient_id, notes } = action.payload;
    const payload = notes ? { notes } : {};

    yield call(AxiosPost, `/mycore/ingredients/${ingredient_id}/approve/`, payload);

    yield put(actions.approveIngredientSuccess());
  } catch (e) {
    yield put(actions.approveIngredientFailure(e.message));
  }
}

function* rejectIngredient(action) {
  try {
    const { ingredient_id, notes } = action.payload;
    const payload = notes ? { notes } : {};

    yield call(AxiosPost, `/mycore/ingredients/${ingredient_id}/reject/`, payload);

    yield put(actions.rejectIngredientSuccess());
  } catch (e) {
    yield put(actions.rejectIngredientFailure(e.message));
  }
}

function* promoteIngredient(action) {
  try {
    const { ingredient_id, notes } = action.payload;
    const payload = notes ? { notes } : {};

    yield call(AxiosPost, `/mycore/ingredients/${ingredient_id}/promote/`, payload);

    yield put(actions.promoteIngredientSuccess());
  } catch (e) {
    yield put(actions.promoteIngredientFailure(e.message));
  }
}

export default function* ingredientApprovalSaga() {
  yield all([
    takeLatest(actions.FETCH_PENDING_INGREDIENTS.REQUEST, fetchPendingIngredients),
    takeLatest(actions.APPROVE_INGREDIENT.REQUEST, approveIngredient),
    takeLatest(actions.REJECT_INGREDIENT.REQUEST, rejectIngredient),
    takeLatest(actions.PROMOTE_INGREDIENT.REQUEST, promoteIngredient),
  ])
}
